import useLazySelector, { useLazyLoader } from "common/redux/useLazySelector";
import * as MerchantActions from 'features/merchants/merchants.actions';
import { ErpIntegrationThin } from "domain/erpIntegration";
import IsLoaded from "common/isLoaded";

const defaultVal = {} as ErpIntegrationThin;
export default function useErpIntegration(): ErpIntegrationThin {
    return useLazySelector(store => store.erpIntegration, MerchantActions.loadMerchantErpIntegrationThin, m => m.userState.activeMerchant.hasErpIntegration, defaultVal);
}

export function useErpIntegrationLoader(): IsLoaded<ErpIntegrationThin> {
    return useLazyLoader(store => store.erpIntegration, MerchantActions.loadMerchantErpIntegrationThin, m => m.userState.activeMerchant.hasErpIntegration, defaultVal);
}